import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface AIMarkdownProps {
  children: string;
}

const AIMarkdown: React.FC<AIMarkdownProps> = ({ children }) => {
  return <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>;
};

export default AIMarkdown;
